export default function Testimonials() {
  const testimonials = [
    {
      name: 'Sarah Mitchell',
      location: 'Portland, OR',
      text: 'The sweetest kitten I\'ve ever owned. Gentle Paws is truly amazing! Our Luna is so calm and affectionate.',
      rating: 5,
      image: 'https://public.readdy.ai/ai/img_res/14f150e885fa12fb3e99d431be974633.jpg'
    },
    {
      name: 'Michael Chen',
      location: 'Seattle, WA',
      text: 'Our Ragdoll is healthy, relaxed, and absolutely gorgeous. The whole adoption process was smooth and professional.',
      rating: 5,
      image: 'https://readdy.ai/api/search-image?query=smiling%20asian%20man%20gently%20holding%20beautiful%20ragdoll%20kitten%20with%20blue%20eyes%20in%20cozy%20home%20interior%20natural%20lighting%20professional%20portrait%20photography%20simple%20clean%20background&width=400&height=400&seq=testimonial-michael-v2&orientation=squarish'
    },
    {
      name: 'Emily Rodriguez',
      location: 'San Francisco, CA',
      text: 'Professional breeder with excellent communication. Highly recommend! Our kitten came with everything we needed to know.',
      rating: 5,
      image: 'https://readdy.ai/api/search-image?query=happy%20woman%20with%20dark%20hair%20cuddling%20gorgeous%20ragdoll%20cat%20with%20bright%20blue%20eyes%20in%20warm%20home%20setting%20natural%20window%20light%20professional%20portrait%20photography%20simple%20clean%20background&width=400&height=400&seq=testimonial-emily-v2&orientation=squarish'
    },
    {
      name: 'David Thompson',
      location: 'Vancouver, BC',
      text: 'Our family fell in love with our Ragdoll instantly. He\'s gentle with our kids and has the most beautiful blue eyes. Thank you Gentle Paws!',
      rating: 5,
      image: 'https://readdy.ai/api/search-image?query=friendly%20man%20with%20short%20hair%20holding%20fluffy%20ragdoll%20kitten%20with%20blue%20eyes%20in%20comfortable%20home%20environment%20natural%20daylight%20professional%20portrait%20photography%20simple%20clean%20background&width=400&height=400&seq=testimonial-david-v1&orientation=squarish'
    },
    {
      name: 'Jessica Park',
      location: 'Los Angeles, CA',
      text: 'Best decision ever! Our Bella is so well-behaved and loving. The health records were thorough and the support after adoption has been wonderful.',
      rating: 5,
      image: 'https://readdy.ai/api/search-image?query=smiling%20woman%20with%20blonde%20hair%20embracing%20beautiful%20ragdoll%20cat%20with%20striking%20blue%20eyes%20in%20bright%20living%20space%20natural%20light%20professional%20portrait%20photography%20simple%20clean%20background&width=400&height=400&seq=testimonial-jessica-v1&orientation=squarish'
    },
    {
      name: 'Robert Williams',
      location: 'Denver, CO',
      text: 'I was nervous about adopting my first cat, but Gentle Paws made it so easy. My Ragdoll is the perfect companion - calm, cuddly, and stunning!',
      rating: 5,
      image: 'https://readdy.ai/api/search-image?query=happy%20man%20with%20glasses%20holding%20adorable%20ragdoll%20kitten%20with%20blue%20eyes%20in%20modern%20home%20setting%20soft%20natural%20lighting%20professional%20portrait%20photography%20simple%20clean%20background&width=400&height=400&seq=testimonial-robert-v1&orientation=squarish'
    },
    {
      name: 'Amanda Foster',
      location: 'Austin, TX',
      text: 'Beautiful kitten with a sweet personality. The adoption process took a bit longer than expected, but worth the wait. Would have appreciated more frequent updates.',
      rating: 4,
      image: 'https://readdy.ai/api/search-image?query=woman%20with%20red%20hair%20holding%20cute%20ragdoll%20kitten%20in%20cozy%20home%20interior%20warm%20lighting%20professional%20portrait%20photography%20simple%20clean%20background&width=400&height=400&seq=testimonial-amanda-v1&orientation=squarish'
    },
    {
      name: 'Kevin Martinez',
      location: 'Phoenix, AZ',
      text: 'Our kitten is adorable and healthy. Communication was good overall, though I wish there were more photos shared during the waiting period. Still very happy with our new family member!',
      rating: 4,
      image: 'https://readdy.ai/api/search-image?query=smiling%20man%20with%20dark%20hair%20holding%20fluffy%20ragdoll%20cat%20in%20comfortable%20living%20room%20natural%20daylight%20professional%20portrait%20photography%20simple%20clean%20background&width=400&height=400&seq=testimonial-kevin-v1&orientation=squarish'
    },
    {
      name: 'Lisa Anderson',
      location: 'Boston, MA',
      text: 'The kitten is lovely and well-cared for. Pickup arrangements were a bit complicated, but the breeder was helpful in working things out. Happy with our Ragdoll overall.',
      rating: 4,
      image: 'https://readdy.ai/api/search-image?query=cheerful%20woman%20with%20short%20brown%20hair%20cuddling%20ragdoll%20kitten%20with%20blue%20eyes%20in%20bright%20home%20setting%20natural%20light%20professional%20portrait%20photography%20simple%20clean%20background&width=400&height=400&seq=testimonial-lisa-v1&orientation=squarish'
    },
    {
      name: 'Thomas Baker',
      location: 'Chicago, IL',
      text: 'Nice kitten, but the adoption fee was higher than other breeders I contacted. The kitten seems healthy though, and the temperament is as described.',
      rating: 3,
      image: 'https://readdy.ai/api/search-image?query=man%20with%20beard%20holding%20ragdoll%20kitten%20in%20home%20interior%20soft%20lighting%20professional%20portrait%20photography%20simple%20clean%20background&width=400&height=400&seq=testimonial-thomas-v1&orientation=squarish'
    },
    {
      name: 'Rachel Green',
      location: 'Miami, FL',
      text: 'The kitten is cute and friendly. Had some initial concerns about the health documentation timing, but everything was eventually provided. Decent experience overall.',
      rating: 3,
      image: 'https://readdy.ai/api/search-image?query=woman%20with%20curly%20hair%20holding%20ragdoll%20cat%20in%20cozy%20home%20environment%20natural%20daylight%20professional%20portrait%20photography%20simple%20clean%20background&width=400&height=400&seq=testimonial-rachel-v1&orientation=squarish'
    },
    {
      name: 'Christopher Lee',
      location: 'San Diego, CA',
      text: 'Our Ragdoll is beautiful and has a gentle nature. The process was okay, though response times to questions varied. The kitten\'s health and personality make up for the minor hiccups.',
      rating: 4,
      image: 'https://readdy.ai/api/search-image?query=smiling%20man%20with%20short%20black%20hair%20holding%20beautiful%20ragdoll%20kitten%20in%20modern%20home%20natural%20lighting%20professional%20portrait%20photography%20simple%20clean%20background&width=400&height=400&seq=testimonial-christopher-v1&orientation=squarish'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold text-gray-900 mb-4">Happy Families & Beautiful Ragdolls</h2>
          <p className="text-xl text-gray-600">See what our adopters have to say about their experience</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
          {testimonials.map((testimonial, index) => (
            <div 
              key={index}
              className="bg-gradient-to-b from-blue-50 to-purple-50 rounded-3xl p-8 shadow-lg hover:shadow-2xl transition-all hover:-translate-y-2"
            >
              <div className="flex items-center mb-6">
                <img 
                  src={testimonial.image}
                  alt={testimonial.name}
                  className="w-20 h-20 rounded-full object-cover object-top mr-4"
                />
                <div>
                  <h3 className="text-xl font-bold text-gray-900">{testimonial.name}</h3>
                  <p className="text-gray-600">{testimonial.location}</p>
                </div>
              </div>
              
              <div className="flex mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-400 text-xl"></i>
                ))}
                {[...Array(5 - testimonial.rating)].map((_, i) => (
                  <i key={`empty-${i}`} className="ri-star-line text-gray-300 text-xl"></i>
                ))}
              </div>
              
              <p className="text-gray-700 leading-relaxed text-lg italic">
                "{testimonial.text}"
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}